// extracted by mini-css-extract-plugin
export default {"background":"Background_background__2ZsJ0","image":"Background_image__sDqSl"};